// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TwitterSquareFilledSvg from "@ant-design/icons-svg/es/asn/TwitterSquareFilled";
import AntdIcon from '../components/AntdIcon';

var TwitterSquareFilled = function TwitterSquareFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: TwitterSquareFilledSvg
  }));
};

TwitterSquareFilled.displayName = 'TwitterSquareFilled';
export default React.forwardRef(TwitterSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/TwitterSquareFilled.js
// module id = 1969
// module chunks = 0